import type { OfferType } from '@makemydeal/dr-platform-types';

import {
    CLEAR_MANUAL_FIELD_OVERRIDES,
    HYDRATE_MANUAL_FIELD_OVERRIDES,
    RESTORE_MANUAL_FIELD_OVERRIDES,
    SET_AUTO_SELECT_CHECKED,
    SET_AUTO_SELECT_DEALER_DEFAULTS,
    SET_MANUAL_FIELD_OVERRIDE
} from '../actionTypes/manualFieldOverridesActionTypes';

// Dispatched from the field components only — the underlying override actions are also fired by the
// payment grid and multi-scenario code, so their action types cannot stand in for "the user did this".
export const setManualFieldOverride = (fieldKey: string) => ({
    type: SET_MANUAL_FIELD_OVERRIDE,
    payload: fieldKey
});

export const MILEAGE_COST_OPTIONS_OVERRIDE_FIELDS = [
    'thresholdMiles',
    'retroMiles',
    'inceptionRate',
    'standardAllowedMiles',
    'excessMileRate'
] as const;

export const PROGRAM_RESET_OVERRIDE_FIELDS = [
    'buyRate',
    'sellRate',
    'baseResidual',
    'acqFee',
    ...MILEAGE_COST_OPTIONS_OVERRIDE_FIELDS
];

export const EXPLICIT_LENDER_CARRIED_OVERRIDE_FIELDS = ['securityDeposit', 'maxResidualizedMsrp'];

export const clearManualFieldOverrides = (fieldKeys?: string[]) => ({
    type: CLEAR_MANUAL_FIELD_OVERRIDES,
    payload: fieldKeys
});

export const hydrateManualFieldOverrides = (fieldKeys: string[]) => ({
    type: HYDRATE_MANUAL_FIELD_OVERRIDES,
    payload: fieldKeys
});

export const restoreManualFieldOverrides = (fieldKeys: string[]) => ({
    type: RESTORE_MANUAL_FIELD_OVERRIDES,
    payload: fieldKeys
});

// Dispatched from the checkbox and from the load path only — never from a fallback.
// `replaceOtherOfferTypes` drops the other deal types' values, which a load needs and a click does not.
export const setAutoSelectChecked = (offerType: OfferType, checked: boolean, replaceOtherOfferTypes = false) => ({
    type: SET_AUTO_SELECT_CHECKED,
    payload: { offerType, checked, replaceOtherOfferTypes }
});

export const setAutoSelectDealerDefaults = (dealerDefaultByOfferType: Partial<Record<OfferType, boolean>>) => ({
    type: SET_AUTO_SELECT_DEALER_DEFAULTS,
    payload: dealerDefaultByOfferType
});
